export const baseApiUrl = 'https://darkgray-caribou-708880.hostingersite.com/btssa/handlers';
export const baseURL = window.location.origin;
// export const baseApiUrl = 'http://localhost/betway/bts/handlers';
// export const baseApiUrl = 'http://192.168.14.148/betway/bts/handlers';